<template>
  <ProductContentDetails
    v-if="offer"
    :offer="offer"
    headline="Produktsicherheit"
    class="product-security"
    :render-item-if="(product) => getList(product)?.length > 0"
  >
    <template #default="props">
      <ProductTabList
        v-if="props.product"
        :list="getList(props.product)"
        class="unstyled-html"
      />
    </template>
  </ProductContentDetails>
</template>

<script setup lang="ts">
import { withDefaults } from 'vue';
import ProductContentDetails from '~/components/product-detail/tabs/product-content-details.vue';
import { getStandardProduct, type Offer, type OfferProduct } from '~/lib/goliath/offer-by-slugs';
import ProductTabList from '~/components/product-detail/tabs/product-tab-list.vue';

export type ProductSecurityProps = {
  offer?: Offer | undefined;
};

const props = withDefaults(defineProps<ProductSecurityProps>(), {
  offer: undefined,
});

const getList = (product: OfferProduct) => {
  const items = [];
  const standardProduct = getStandardProduct(product);
  if (standardProduct?.family) {
    if ('manufacturerContact' in standardProduct.family) {
      items.push({
        name: 'Herstellerinformationen',
        value: standardProduct.family.manufacturerContact,
      });
    }
    if ('manufacturerContactEu' in standardProduct.family) {
      items.push({
        name: 'Verantwortliche Person für die EU',
        value: standardProduct.family.manufacturerContactEu,
      });
    }
  }
  if (standardProduct?.securityInformationUrl) {
    items.push({
      name: '',
      value: `<a href="${standardProduct.securityInformationUrl}" target="_blank" rel="nofollow">Sicherheitsdatenblatt auf der Webseite des Herstellers</a>`,
    });
  }
  return items;
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.product-security {
}
</style>
